import { createRoot } from 'react-dom/client';
import { BrowserRouter  } from "react-router-dom";
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.scss';
import 'primeicons/primeicons.css'

import './app.scss';
import { AuthProvider } from "./hooks/useAuth";
import App from './App';

import ReactGA from "react-ga4";

// ccw 2026-10-26 consent-mode: start GA only once the visitor has Performance (C0002) consent.
// OptanonWrapper in public/index.html sets window.neurelisConsent and fires neurelis:consent
// on load and on every change. Revoking later is handled there (consent update + ga-disable).
let gaStarted = false
const fncStartGA = () => {
	if (gaStarted) return
	gaStarted = true
	ReactGA.initialize("G-643KR69CB9");
}
if (window.neurelisConsent && window.neurelisConsent.performance) fncStartGA()
window.addEventListener('neurelis:consent', (e) => {
	if (e.detail && e.detail.performance) fncStartGA()
})

const root = createRoot(document.getElementById('root'));



root.render(
	<BrowserRouter >
		<AuthProvider>
			<App />
		</AuthProvider>
	</BrowserRouter >
);
